// taken from https://github.com/wix-private/metro-packages/blob/28e61eeccdf935e303bf210194f5eb57ecf336db/packages/ambassador/restaurants-menus-v1-item/types.impl.ts#L527

export let ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["BULK_DELETE_ITEMS"] = "Delete items error";
  ErrorTypes["BULK_DELETE_VARIANTS"] = "Delete variants error";
  ErrorTypes["BULK_DELETE_MODIFIERS"] = "Delete modifiers error";
  ErrorTypes["BULK_DELETE_LABELS"] = "delete labels error";
  return ErrorTypes;
}({});
//# sourceMappingURL=api.js.map